import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import {Link} from 'react-router-dom';
import lang from '../../constants/Languages.js';

const ChangeQuery = ({ clang }) => {
    return (
        <div className="advanced-search-results__change">
            <Link to={'/advanced-search'} className="advanced-search-results__change-link">
                {lang[clang].advanced_search_results.change_query}
            </Link>
        </div>
    );
};

ChangeQuery.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(ChangeQuery);



// WEBPACK FOOTER //
// ./src/components/advanced-search/ChangeQuery.js